import { useStore } from "@priolo/jon";
import CropIcon from "images/menu/crop";
import { FunctionComponent, useMemo, useState } from "react";
import farmSo from "stores/farm";
import cropRecipeSo from "stores/library/cropRecipe";
import { getItemsFiltered } from "stores/tag/utils";
import { CropRecipe } from "types/CropRecipe";
import ListTags from "../ListTags";
import SelectorDialogBase from "../base/SelectorDialogBase";
import WrapControl, { ICON_VARIANT, WrapControlProps } from "../base/WrapControl";



interface Props extends WrapControlProps {
	/** filtro sulla GROW-UNIT da utilizzare */
	farmId?: number,
	/** il CROP ID selezionato */
	cropRecipeId?: number,
	/** quando si seleziona un CROP  */
	onChange: (cropRecipe: CropRecipe) => void,
}
const SelectorCropRecipe: FunctionComponent<Props> = ({
	farmId,
	cropRecipeId,
	onChange,
	...props
}) => {

	// STORE
	useStore(cropRecipeSo)

	// HOOKs
	const [isOpen, setIsOpen] = useState(false)
	const [textFilter, setTextFilter] = useState("")

	// HANDLER
	const handleClick = () => setIsOpen(true)
	const handleClose = (cropRecipeSelect: CropRecipe) => {
		setIsOpen(false)
		if (!!cropRecipeSelect) onChange?.(cropRecipeSelect)
	}

	// RENDER
	const cropRecipes = useMemo(() => {
		return getItemsFiltered(cropRecipeSo.state.all, { txt: textFilter, farmId: farmSo.state.select?.id })
	}, [cropRecipeSo.state.all, textFilter, farmId])
	const cropSelect = useMemo(() => cropRecipeSo.getById(cropRecipeId), [cropRecipeId])

	return (<>
		<WrapControl
			variantIcon={ICON_VARIANT.PAGE}
			textValue={cropSelect?.name ?? ""}
			onClick={handleClick}
			{...props}
		/>
		<SelectorDialogBase
			icon={<CropIcon />}
			title="SELECT A CROP-RECIPE"
			maxWidth="sm"
			items={cropRecipes}
			textValue={textFilter}
			idSelect={cropRecipeId}
			isOpen={isOpen}
			onClose={handleClose}
			onChangeTextValue={txt => setTextFilter(txt)}
			fnTextFromItem={item => (
				<span style={{ fontSize: "15px", fontWeight: "500" }}>{item.name}</span>
			)}
			fnSecondaryFromItem={item => <ListTags tags={item.tagList} autotags={item.autotagList} />}
			fnIdFromItem={item => item.id}
		/>
	</>)
}

export default SelectorCropRecipe

